import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numbersFormat'
})
export class NumbersFormatPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    const stringParse = parseInt(value, 10);
    const removingDots = Math.trunc(stringParse);
    return removingDots.toLocaleString('en-US', {
      // style: 'currency',
      // currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    // var parts = value.toString().split('.');
    // parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    // return parts.join(',');
  }
}
